// Copyright (c) 2022 by Move Closer

export interface CustomerSupportData {
  email?: string
  phone?: string
  firstName?: string
  lastName?: string
}

export interface CustomerSupportRegistryData extends CustomerSupportData {
  regionId: number
}

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export interface ICustomerSupportService {
  getContactData (regionId: number | undefined): CustomerSupportData | null
}

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const CustomerSupportServiceType = Symbol.for('ICustomerSupportService')
